import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BookService } from 'src/app/shared/book.service';

declare let alertify: any;
declare let localforage: any;
declare let window: any;

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.css']
})
export class SearchResultsComponent implements OnInit {
  paramsObject: any;
  id: string = "";
  code: string = "";
  listBook?: any[];
  urlImage: string = "";
  urlImage2: string = "";
  bookItem = {};
  bookCode: any;
  bookDetail: any;
  constructor(private activatedRoute: ActivatedRoute,
    private service: BookService) { }

  ngOnInit(): void {
    this.handleParams();
  }

  handleParams() {
    this.activatedRoute.queryParamMap.subscribe(it => {
      this.paramsObject = { ...it };
      this.id = decodeURIComponent(this.paramsObject.params.id);
      this.code = this.paramsObject.params.code;
      this.getBookDetailFromRouter();

    });
  }

  imageProcessKeyword(filename: string, sourcefolder: string) {
    var lowerfilename = filename;
    lowerfilename = lowerfilename.toLocaleLowerCase();

    var newfilename = lowerfilename;
    if (newfilename.indexOf(" ") >= 0) {
      newfilename = newfilename.replace(/ /g, "_");
    } else if (filename.indexOf("/") >= 0) {
      newfilename = filename.replace("/", "-");
    } else if (filename.indexOf("'") >= 0) {
      newfilename = filename.replace("'", "_");
    }
    var url = window.__static + `/static/${sourcefolder}${newfilename}.png`;
    return url;
  }

  getBookDetailFromRouter(): void {
    var booksOnline = this.service.getBooks();
    var products: any = (booksOnline as any).default;
    var listItem = [];
    const keys = Object.keys(products);
    for (const property in products) {
      listItem.push(products[property]);
    }
    this.listBook = listItem.map((item, index) => {
      var biletkeyword = item.biletkeywords;
      var keyword1: string;
      var keyword2: string;
      var book: string;
      var category: string;
      biletkeyword.forEach((it: any, idx: number) => {
        keyword1 = it.keyword1.keyword_en;
        keyword2 = it.keyword2.keyword_en;
        book = item.code;
        category = it.category;
        this.urlImage = this.imageProcessKeyword(
          keyword1,
          book + "/image/" + category + "/"
        );
        this.urlImage2 = this.imageProcessKeyword(
          keyword2,
          book + "/image/" + category + "/"
        );
        it.keyword1.urlKeyword1 = this.urlImage;
        it.keyword2.urlKeyword2 = this.urlImage2;
      });
      item.biletcategory.forEach((o: any, idx: number) => {
        var urlIm = this.imageProcessKeyword(o.id, book + "/image/");
        item.biletcategory[idx].url = urlIm;
        item.biletcategory[
          idx
        ].background = window.__static + `/static/${item.code}/image/background_stretch.png`;
      });

      return {
        ...item,
        biletcategory: item.biletcategory,
      };
    });

    this.listBook.find((i) => {
      if (i.code == this.code) {
        this.bookCode = i;
        return this.bookCode;
      }
      return;
    });
    this.bookDetail = this.bookCode.biletkeywords.find((o: any) => {
      if (o.id === this.id) {
        return o;
      }
    });
  }
}
